/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressDto } from './addressDto';


export interface PaymentAccountUnconfirmedAddDto { 
    fakturaCustomerRefNo: number;
    invoiceAddress: AddressDto;
    prePayment: boolean;
    currency: PaymentAccountUnconfirmedAddDto.CurrencyEnum;
    acceptedOldAirtimeAgreement: boolean;
    acceptedNewDataPlanAirtimeAgreement: boolean;
    userAccountIdOfTheAccountOwner: number;
}
export namespace PaymentAccountUnconfirmedAddDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
}


